import * as Action from '../action';

const initialState = {
  dialogVisibility: false,
  uploading: false,
  selectedDocType: '',
  message: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.UPLOADING_SPPB:
      return { ...state, uploading: action.status };
    case Action.SET_SPPB_SELECTED_DOC_TYPE:
      return { ...state, selectedDocType: action.option };
    case Action.SET_SPPB_INFO_DIALOG_VISIBILITY:
      return { ...state, dialogVisibility: action.status, message: action.text || '' };
    default: return state;
  }
};
